export { httpClient as apiClient } from '@/lib/http-client'
export { httpClient } from '@/lib/http-client'

// Feature APIs — imported from their canonical feature folders.
import { authApi } from '@/features/auth/api'
import { usersApi } from '@/features/users/api'
import { organizationsApi } from '@/features/organizations/api'
import { assessmentsApi } from '@/features/assessments/api'


import { resultsApi } from '@/features/results/api'
import { projectInitiativesApi } from '@/features/project-initiatives/api'
import { settingsApi } from '@/features/settings/api'
import { statsApi, backendApi } from '@/features/stats/api'
import { auditApi } from '@/features/audit/api'
import { industriesApi } from '@/features/industries/api'
import { rolesApi } from '@/features/roles/api'

// Assessment engine sub-APIs — composed directly from feature imports.
import { domainsApi } from '@/features/domains/api'
import { engineQuestionsApi } from '@/features/questions/api'
import { maturityLevelsApi } from '@/features/maturity-levels/api'
import { scoreLabelsApi } from '@/features/scoring-labels/api'

export const api = {
  auth: authApi,
  users: usersApi,
  organizations: organizationsApi,
  assessments: assessmentsApi,


  results: resultsApi,
  projectInitiatives: projectInitiativesApi,
  export: resultsApi,
  settings: settingsApi,
  stats: statsApi,
  audit: auditApi,
  backend: backendApi,
  industries: industriesApi,
  roles: rolesApi,

  assessmentEngine: {
    domains: domainsApi,
    questions: engineQuestionsApi,
    maturityLevels: maturityLevelsApi,
    scoreLabels: scoreLabelsApi,
  },
}
